import { render } from "./VitalList.vue?vue&type=template&id=9a31c80a&scoped=true"
import script from "./VitalList.vue?vue&type=script&lang=js"
export * from "./VitalList.vue?vue&type=script&lang=js"

import "./VitalList.vue?vue&type=style&index=0&id=9a31c80a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/medsien-patient-app/medsien-patient-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a31c80a"]])

export default __exports__